import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { Sparkles, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function GenerateProgress() {
  const { id } = useParams();
  const nav = useNavigate();
  const [list, setList] = useState(null);
  const [progress, setProgress] = useState(5);

  useEffect(() => {
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/lead-lists/${id}`);
        if (!active) return;
        setList(data);
        if (data.status === "ready") {
          nav(`/lists/${id}`, { replace: true });
        }
      } catch { /* ignore */ }
    };
    poll();
    const t = setInterval(poll, 2500);
    const p = setInterval(() => setProgress((v) => (v < 92 ? v + 3 : v)), 1200);
    return () => { active = false; clearInterval(t); clearInterval(p); };
  }, [id, nav]);

  if (!list) {
    return (
      <div className="min-h-screen"><Nav /><div className="max-w-3xl mx-auto px-6 py-20 text-muted-foreground">Loading…</div></div>
    );
  }

  if (list.status === "failed") {
    return (
      <div className="min-h-screen">
        <Nav />
        <main className="max-w-xl mx-auto px-6 py-20 text-center">
          <div className="w-14 h-14 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto">
            <AlertTriangle className="w-6 h-6 text-red-400" />
          </div>
          <h1 className="mt-6 text-3xl font-medium tracking-tight">Generation failed</h1>
          <p className="mt-3 text-muted-foreground text-sm">{list.error || "Something went wrong. Your credit has been refunded."}</p>
          <Button onClick={() => nav("/new")} className="mt-8 rounded-full bg-primary hover:bg-[#FF7043] text-white" data-testid="retry-btn">
            Try again
          </Button>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Nav />
      <main className="max-w-xl mx-auto px-6 py-24 text-center">
        <div className="w-14 h-14 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center mx-auto animate-pulse">
          <Sparkles className="w-6 h-6 text-primary" />
        </div>
        <h1 className="mt-6 text-3xl font-medium tracking-tight">Researching your market…</h1>
        <p className="mt-3 text-muted-foreground text-sm">
          Finding {list.count} companies in {list.location} that match your offering.
        </p>
        <div className="mt-10">
          <Progress value={progress} className="h-1.5" data-testid="progress-bar" />
          <div className="mt-3 text-xs text-muted-foreground">{progress}% • this usually takes 30–90 seconds</div>
        </div>
      </main>
    </div>
  );
}
